const getUtf8Bytes = string => {
  const encoder = new TextEncoder('utf-8')
  return encoder.encode(string)
}

const uInt8ToHex = data => Array.prototype.map.call(data, x => x.toString(16).padStart(2, '0')).join('')

const getCryptoKey = key => {
  const uInt8ArrayKey = getUtf8Bytes(key)

  const algorithm = { name: 'HMAC', hash: 'SHA-256' }

  return window.crypto.subtle.importKey('raw', uInt8ArrayKey, algorithm, false, ['sign', 'verify'])
}

const getHMACDigest = async (message, key) => {
  const cryptoKey = await getCryptoKey(key)
  const uInt8ArrayMessage = getUtf8Bytes(message)

  const signature = await window.crypto.subtle.sign('HMAC', cryptoKey, uInt8ArrayMessage)
  const uInt8ArraySignature = new Uint8Array(signature)
  const digest = uInt8ToHex(uInt8ArraySignature)

  return digest
}

export const identifyCandidate = async (currentUser, candidateProfile) => {
  const { currentState, slug } = candidateProfile

  if (currentState === 'ONBOARDING') {
    return
  }

  const digest = process.env.REACT_APP_INTERCOM_SECRET_KEY
    ? await getHMACDigest(currentUser.id, process.env.REACT_APP_INTERCOM_SECRET_KEY)
    : ''

  analytics.identify(
    currentUser.id,
    {
      name: currentUser.name,
      email: currentUser.email,
      createdAt: currentUser.created_at,
      state: currentState,
      slug,
      traits: {
        user_type: 'candidate',
      },
      user_type: 'candidate',
    },
    {
      Intercom: {
        user_hash: digest,
        hideDefaultLauncher: currentState !== 'LIVE' && currentState !== 'POST_LIVE',
      },
    },
  )
}
